import { apiGetClient, apiPostClient, apiPutClient, apiPostImageClient } from "../../api/apiSvtAdmin";
import { toast } from 'react-toastify';
import { t } from 'i18next';

export const getSectorsList = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/sectors");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getBusinessUnitsList = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/business-units");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSubBusinessUnitsList = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/sub-business-units");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getLegalEntitiesList = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/legal-entities");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getCompanyTiers = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/tiers");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getParentOrganization = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/parent");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const addNewOrganization = async (data) => {
    try {
        const response = await apiPostClient.post("foundation/company", data);
    toast.success(t("organizationAddedSuccessfully", { organizationName: data.organizationName }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const uploadOrganizationFiles = async (data) => {
    try {
        const response = await apiPostImageClient.post("foundation/company/entity/upload", data);
        toast.success(t("fileUploadedSuccessfully"), { position: "top-center", theme: "dark" });
        return response.data;
    } catch (error) {
        toast.error(error.response.data?.error, { position: "top-center" });
        return error.response.data;
    }
};

export const updateOrganization = async (data, orgId) => {
    try {
        const response = await apiPutClient.put(`foundation/company/${orgId}`, data);
    toast.success(t("organizationUpdatedSuccessfully", { organizationName: data.organizationName }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const downloadOrgFile = async () => {
    try {
        const response = await apiGetClient.get(`foundation/download/blank-template`, {
            responseType: "blob",
        });
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center", theme: "dark" });
        return null;
    }
};
